export default "__VITE_ASSET__OhKBM3mw__"